module.exports = __webpack_public_path__ + "img/r-235.283d1ee4.jpg";